export default {"src":"/_next/static/media/TOAST_ERROR.bfefb0db.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};